import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "madrid-home" }
const _hoisted_2 = { class: "madrid-home__header" }
const _hoisted_3 = {
  key: 0,
  class: "madrid-home__routes"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "madrid-home__bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", null, [
        _createElementVNode("p", null, _toDisplayString(_ctx.description), 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1))
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "madrid-home__warning" }, [
      _createElementVNode("span", null, "VERSIÓN EN PRUEBAS DEL AYUNTAMIENTO DE MADRID. SEGUIMOS TRABAJANDO")
    ], -1)),
    (_ctx.routes)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
            return (_openBlock(), _createElementBlock("li", { key: route }, [
              _createElementVNode("div", {
                style: _normalizeStyle({ backgroundImage: `url(${route.image})` })
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", null, "DISTRITO", -1)),
                      _createElementVNode("span", null, _toDisplayString(route.locations.length) + " PARADAS", 1)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(route.name), 1)
                  ]),
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.goToRoute(route))
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("span", null, "VER RUTA", -1),
                    _createElementVNode("span", null, null, -1)
                  ]), 8, _hoisted_4)
                ])
              ], 4)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", null, " Sumérgete en la historia de Madrid con sus rutas interactivas ", -1)),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToTop()))
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("span", null, "VOLVER ARRIBA", -1),
        _createElementVNode("span", null, null, -1)
      ])),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "madrid-home__bottom--logo" }, null, -1)),
      _createElementVNode("span", null, "v" + _toDisplayString(_ctx.appVersion), 1)
    ])
  ]))
}